import { Component, Input, AfterViewInit } from '@angular/core';
import * as Chartist from 'chartist';
import 'chartist-plugin-tooltips';
import { Observable } from 'rxjs';
import { ParameterData } from '../_helpers/parameter.data';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { DataService } from '../_helpers/dataservice.service'

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';


@Component({
  selector: 'chartist',
  template: `
          <div id="chart"></div>
`,
  styleUrls: ['../../assets/css/chartist-custom.css']
})
export class ChartistComponent implements AfterViewInit {
  @Input() namess: string;

  isLoading = true;
  data: any;
  dataPayment: any;
  temp: any;
  graphDataJson: any;

  graphStatData: any;
  labelsArray = [];

  invoiceSeriesArray = [];
  paymentSeriesArray = [];
  invoiceCountTotal: any;

  invoiceTotalSum: number;
  invoiceCountSum: number;

  paymentTotalSum: number;
  paymentCountSum: number;

  private eventsSubscription: any
  @Input() events: Observable<void>;

  constructor(private http: HttpClient, private parameterData: ParameterData, private datePipe: DatePipe
    , private dataService: DataService
    , private spinnerService: Ng4LoadingSpinnerService
  ) {


  }//end const




  ngOnInit() {
    this.eventsSubscription = this.events.subscribe(() => this.ngAfterViewInit())
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe()
  }




  ngAfterViewInit() {

    this.isLoading = true;


    const optionsLineChart = {
      axisX: {
        showGrid: false
      },

      axisY: {
        offset: 50
      },
      low: 0,


      chartPadding: { top: 0, right: 5, bottom: 0, left: 0 }
      , plugins: [
        Chartist.plugins.tooltip(
          {
            textAnchor: 'middle'
            , pointClass: 'my-cool-point',
            currency: 'Total: '
          }
        )
      ]
    };//end oprion



   // setTimeout(() => {

      this.dataService.currentChartDataPayment.subscribe(message => this.data = message)


      new Chartist.Line(
        '#chart',
        this.data,
        optionsLineChart
      )
        .on("draw", function (data) {
          if (data.type === "point") {
            data.element._node.setAttribute("title", "Value: " + data.value.y);
            data.element._node.setAttribute("data-chart-tooltip", "chart");


            var circle = new Chartist.Svg('circle', {
              cx: [data.x],
              cy: [data.y],
              r: [4],
              'ct:value': data.value.y,
              'ct:meta': data.meta,
              class: 'my-cool-point',

            }, 'ct-area');

            data.element.replace(circle);

          }//end if

          if (data.type === 'line' || data.type === 'area') {
            data.element.animate({
              d: {
                begin: 1000 * data.index,
                dur: 1000,
                from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
                to: data.path.clone().stringify(),
                easing: Chartist.Svg.Easing.easeOutQuint
              }
            });
          }






        }).on("created", function () {
          $("#chart").tooltip({
            selector: '[data-chart-tooltip="chart"]',
            container: "#chart",
            html: true
          });
        });
    //}, 0);




    this.isLoading = false;











  }//ng after initview


}//end class
